import React from "react";
import { DropdownMenu } from "@/components/ui/dropdown-menu";
import { DropdownMenuContent } from "@/components/ui/dropdown-menu";
import { DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { PlacesFiltersProps } from "../types";
import { useTranslation } from "@/lib/i18n";

export const PlacesFilters: React.FC<PlacesFiltersProps> = ({
  categories,
  selectedFilter,
  onFilterChange,
}) => {  
  const { t } = useTranslation();
  
  const itemClass = "my-[8px] rounded-lg p-[8px]";
  const itemUnselected =
    "bg-secondary focus:bg-secondary focus:text-secondary-foreground";
  const itemSelected =
    "bg-softWhite text-softWhite-foreground focus:bg-softWhite focus:text-softWhite-foreground";

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="ml-[8px] md:ml-[-4px]">
        <div
          className="pointer-events-auto flex items-end gap-[4px] md:gap-[5px] h-full"
          aria-label="Places category filter"
        >
          <span className="text-foreground text-sm font-medium leading-none">
            {t(`places_categories.${selectedFilter}`)}
          </span>
          <ChevronDown size={16} color={"hsl(var(--foreground))"} />
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="bg-background rounded-lg border-tertiary px-[8px] ml-[8px] md:ml-[10px]"
        sideOffset={8}
      >
        {categories.map((filter) => (
          <DropdownMenuItem
            key={filter}
            id={filter}
            onClick={() => onFilterChange(filter)}
            className={`${itemClass} ${
              selectedFilter === filter ? itemSelected : itemUnselected
            }`}
          >
            {t(`places_categories.${filter}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
